import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from './Button';
import { getCurrentUser } from '../services/api';
import './Layout.css';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getCurrentUser();
        setUser(response.data);
      } catch (error) {
        console.error("Failed to fetch user", error);
        // Handle error, e.g., by logging out
        if (error.response && error.response.status === 401) {
          handleLogout();
        }
      }
    };

    fetchUser();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div className="layout-container">
      <aside className="sidebar">
        <nav>
          <ul>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><Link to="/play-to-earn">Play to Earn</Link></li>
            <li><Link to="/payments">Payments</Link></li>
            <li><Link to="/courses">Courses</Link></li>
            <li><Link to="/settings">Settings</Link></li>
            {user && user.username === 'omnichannel200@gmail.com' && (
              <li><Link to="/admin">Admin</Link></li>
            )}
          </ul>
        </nav>
        <div className="sidebar-footer">
          <Button onClick={handleLogout}>Logout</Button>
        </div>
      </aside>
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;